import styled from 'styled-components';

import { theme } from 'assets/styles/theme';
import { Text2Bold } from 'components/typography/Texts';

export const ExternalLinkButton = styled(Text2Bold.withComponent('a'))`
  cursor: pointer;
  color: ${theme.color.red};
`;
